import { CreditCardForm, CreditCardFormProps } from 'forms/CreditCardForm';
import { LoadGoogleMaps } from 'components/maps/LoadGoogleMaps';
import { useIsGoogleMapsLoaded } from 'components/maps/useIsGoogleMapsLoaded';
import React from 'react';

export type LocationAwareCreditCardFormProps = CreditCardFormProps;

const LocationAwareCreditCardForm: React.FunctionComponent<LocationAwareCreditCardFormProps> = (
  props
) => {
  const { isLoaded: isGoogleMapsLoaded } = useIsGoogleMapsLoaded();

  return (
    <>
      <LoadGoogleMaps />
      {isGoogleMapsLoaded && <CreditCardForm {...props} />}
    </>
  );
};

export default LocationAwareCreditCardForm;
